import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useContent } from "../context/ContentContext";

const SITE_URL = "https://stoofvinkeveen.nl";

const pageKey = (pathname) => {
  if (pathname === "/") return "home";
  if (pathname === "/occasions") return "occasions";
  if (pathname.startsWith("/occasions/")) return null; // detail: CarDetail regelt eigen SEO
  if (pathname.startsWith("/werkplaats")) return "werkplaats";
  if (pathname.startsWith("/avia")) return "avia";
  if (pathname.startsWith("/over-ons")) return "over";
  if (pathname.startsWith("/contact")) return "contact";
  if (pathname.startsWith("/afspraak")) return "afspraak";
  return null;
};

const OG_IMAGE = {
  home: "og-home", occasions: "og-occasions", werkplaats: "og-werkplaats",
  avia: "og-avia", over: "og-over", contact: "og-contact", afspraak: "og-werkplaats",
};

const setMeta = (name, content, attr = "name") => {
  if (!content) return;
  let m = document.querySelector(`meta[${attr}="${name}"]`);
  if (!m) { m = document.createElement("meta"); m.setAttribute(attr, name); document.head.appendChild(m); }
  m.setAttribute("content", content);
};

const setCanonical = (href) => {
  let l = document.querySelector('link[rel="canonical"]');
  if (!l) { l = document.createElement("link"); l.setAttribute("rel", "canonical"); document.head.appendChild(l); }
  l.setAttribute("href", href);
};

export const SeoManager = () => {
  const { get } = useContent();
  const { pathname } = useLocation();

  useEffect(() => {
    const canonical = SITE_URL + (pathname === "/" ? "/" : pathname);
    setCanonical(canonical);
    setMeta("og:url", canonical, "property");
    setMeta("twitter:card", "summary_large_image");

    const key = pageKey(pathname);
    if (!key) return; // occasion-detail: CarDetail zet titel/omschrijving/afbeelding

    const title = get(`seo.${key}.title`, null);
    const desc = get(`seo.${key}.description`, null);
    if (title) { document.title = title; setMeta("og:title", title, "property"); setMeta("twitter:title", title); }
    if (desc) { setMeta("description", desc); setMeta("og:description", desc, "property"); setMeta("twitter:description", desc); }

    const img = `${SITE_URL}/${OG_IMAGE[key] || "og-home"}.jpg`;
    setMeta("og:image", img, "property");
    setMeta("twitter:image", img);
  }, [pathname, get]);

  return null;
};
